
const Contact = ({ ref, lightMode }) => {
    return (
        <div ref={ref} className={'section ' + (lightMode ? 'light-primary' : 'dark-primary')}>
            <p className="norm-header">Contact</p>
            <p className="contact-text">I am currently available to get involved in new projects, so get in touch if you'd like to work together. <br />
                <br />
                Email me at <span><a href="mailto:ogogorchimadika6@gmail.com">ogogorchimadika6@gmail.com </a></span>and lets talk about your project!
            </p>
        </div>
    )
}

export default Contact
